import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect, Provider, useStore } from 'react-redux'
import { Form as Base } from 'react-redux-form'
import find from 'lodash/fp/find'

const propTypes = {
  form: PropTypes.shape({
    $form: PropTypes.object.isRequired,
  }).isRequired,
  children: PropTypes.node,
}

const mapStateToProps = (state, { model }) => ({
  form: state[`${model}Form`],
})

function findNestedInvalidForm(fields) {
  const invalidKeys = Object.keys(fields).filter(
    key => fields[key] && fields[key].$form && fields[key].$form.valid === false
  )
  return fields[invalidKeys[0]].$form
}

/**
 * Extends react-redux-form and try to scroll first invalid form element to view
 */
const Form = props => {
  const { form } = props
  const [newSubmit, setNewSubmit] = useState(false)
  const { $form } = form


  useEffect(() => {
    // Change state after form submit button click (intents contains submit for while)
    const newSubmitState = !!find({ type: 'submit' })($form.intents)
    if (newSubmitState && $form && $form.intents) {
      setNewSubmit(newSubmitState)
    }
  },[$form])

  useEffect(() => {
    const { $form, ...fields } = form
    const notSubmitting = !find({ type: 'submit' })($form.intents)
    // Check if just submitted form
    if ($form.submitFailed && newSubmit && notSubmitting) {
      const field =
        find({ valid: false })(fields) || findNestedInvalidForm(fields)
      if (!field) {
        return
      }
      if (field) {
        const element = document.querySelector(`[name="${field.model}"]`)
        if (element) {
          element.scrollIntoView()
        }
      }
      // Reset submit state or scroll will happen always.
      setNewSubmit(false)
    }
  }, [newSubmit])

  const store = useStore()

  return <Base {...props} store={store} />
}

Form.propTypes = propTypes

export default connect(mapStateToProps)(Form)
